import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import { Card, Image, Row, Col, Container } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";

import hildaImage from "../Image/DarkLogo.png";
import johnImage from "../Image/DarkLogo.png";
import janeImage from "../Image/DarkLogo.png";
import jayImage from "../Image/DarkLogo.png";

const Testimonial = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isScrollingDown, setIsScrollingDown] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    customPaging: () => {
      return <div className="custom-dot mt-5" />;
    },
    appendDots: (dots) => (
      <div>
        <ul className="d-flex justify-content-center list-unstyled">{dots}</ul>
      </div>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const testimonials = [
    {
      text: t("testimonial1"),
      name: t("testimonialName1"),
      location: t("testimonialLocation1"),
      testimonialImage: hildaImage,
    },
    {
      text: t("testimonial2"),
      name: t("testimonialName2"),
      location: t("testimonialLocation2"),
      testimonialImage: johnImage,
    },
    {
      text: t("testimonial3"),
      name: t("testimonialName3"),
      location: t("testimonialLocation3"),
      testimonialImage: janeImage,
    },
    {
      text: t("testimonial4"),
      name: t("testimonialName4"),
      location: t("testimonialLocation4"),
      testimonialImage: jayImage,
    },
    {
      text: t("testimonial5"),
      name: t("testimonialName5"),
      location: t("testimonialLocation5"),
      testimonialImage: jayImage,
    },
  ];

  useEffect(() => {
    const sectionElement = sectionRef.current;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setIsScrollingDown(currentScrollY > lastScrollY);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && isScrollingDown) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      { threshold: 0.5 }
    );

    if (sectionElement) {
      observer.observe(sectionElement);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (sectionElement) {
        observer.unobserve(sectionElement);
      }
    };
  }, [lastScrollY, isScrollingDown]);

  return (
    <section
      ref={sectionRef}
      className={`pt-0 pb-5 bg-white text-center ${
        isVisible ? "animate__animated animate__fadeIn" : ""
      }`}
      id="testimonials"
    >
      <Container className="justify-content-center">
        <Row className="m-0">
          <Col lg={12} className="justify-content-center d-flex p-0">
            <div className="headingTextMain">
              <h2
                className={`text-center mb-2 feature-title animate__animated ${
                  isVisible ? "animate__fadeIn" : ""
                }`}
              >
                {t("testimonialHeader")}
              </h2>
              {/* <h2
                className={`text-center mb-2 headingText2 mb-lg-4 mb-sm-3 animate__animated ${
                  isVisible ? "animate__fadeIn" : ""
                }`}
              >
                {t("clientFeedback")}
              </h2> */}
            </div>
          </Col>
        </Row>
        <div className="col-lg-12 mt-3 my-5">
          <Slider {...settings}>
            {testimonials.map((testimonial, index) => (
              <Card
                key={index}
                className="TestimonialCard d-flex h-100 p-2 border-0 mb-4 rounded-2"
              >
                <Card.Body className="TestimonialCardBody d-flex h-100 rounded-2 p-2">
                  <Card.Text className="test_card_text_1 text-center fs-6 fst-italic">
                    "{testimonial.text}"
                  </Card.Text>
                </Card.Body>
                <Card.Footer className="bg-white border-0 text-center d-flex align-items-end justify-content-center mt-3">
                  <Row className="align-items-center">
                    <Col lg={12} className="d-flex align-items-center">
                      <div className="profile-image-wrapper p-0">
                        <Image
                          src={testimonial.testimonialImage}
                          roundedCircle
                          alt="Profile"
                          width="70"
                          height="70"
                          className="profile-image mx-2"
                        />
                      </div>
                      {/* </Col>
                    <Col xs={9} className="text-center p-0"> */}
                      <div className="mx-2">
                        <h6 className="mb-0 test_card_text_2 fw-bold">
                          {testimonial.name}
                        </h6>
                        <small className="test_card_text_3">
                          {testimonial.location}
                        </small>
                      </div>
                    </Col>
                  </Row>
                </Card.Footer>
              </Card>
            ))}
          </Slider>
        </div>
      </Container>
    </section>
  );
};

export default Testimonial;
